import { render, staticRenderFns } from "./rezervasyonDetay.vue?vue&type=template&id=a2280d94&scoped=true&"
import script from "./rezervasyonDetay.vue?vue&type=script&lang=js&"
export * from "./rezervasyonDetay.vue?vue&type=script&lang=js&"
import style0 from "./rezervasyonDetay.vue?vue&type=style&index=0&id=a2280d94&lang=scss&scoped=true&"
import style1 from "./rezervasyonDetay.vue?vue&type=style&index=1&lang=css&"
import style2 from "./rezervasyonDetay.vue?vue&type=style&index=2&id=a2280d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2280d94",
  null
  
)

export default component.exports